import * as React from 'react';

import { VerticalAlignment } from '@gitbook/api-client';

/** Context to access the current vertical alignment. */
export const VerticalAlignmentContext = React.createContext<VerticalAlignment>(
    VerticalAlignment.Middle
);

/** Column id's mapped to their widths */
export type ColumnWidthsMap = Map<string, number>;

/** Context providing a map with each column's width */
export const ColumnWidthsContext = React.createContext<ColumnWidthsMap>(new Map());
